import { render, staticRenderFns } from "./damage-theft-buttons.vue?vue&type=template&id=576b3e9a&"
import script from "./damage-theft-buttons.vue?vue&type=script&lang=js&"
export * from "./damage-theft-buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports